import React from 'react'

import { SxProps } from '@mui/material'

import { TMetricQueryParams, TMetricSettings } from 'types/GlobalMetric'
import { CustomPeriodFilter, PeriodFilter } from 'types/GlobalWidget'

import MetricFooter from 'components_new/organisms/MetricFooter'

import { applyPeriodToQueryParams } from 'utils/metricQueryParams'

interface Props {
  chart: 'bar' | 'line'
  id: string
  onChangeChart: (value: 'bar' | 'line') => void
  queryParams: TMetricQueryParams
  setQueryParams: (params: TMetricQueryParams) => void
  settings: TMetricSettings
  sx?: SxProps
}

const MetricQueryParamsFooter = (props: Props) => {
  const {
    chart,
    id,
    onChangeChart,
    queryParams,
    setQueryParams,
    settings,
    sx
  } = props

  let period: PeriodFilter | CustomPeriodFilter =
    queryParams.period_filter ?? PeriodFilter.LAST_12_MONTHS_TO_TODAY

  if (queryParams.from_date && queryParams.to_date) {
    period = {
      from: queryParams.from_date,
      to: queryParams.to_date
    }
  }

  return (
    <MetricFooter
      chart={chart}
      id={id}
      onChangeChart={onChangeChart}
      onChangePeriod={(period) =>
        setQueryParams(applyPeriodToQueryParams(queryParams, period))
      }
      onChangeRealEstates={(realEstates) =>
        setQueryParams({
          ...queryParams,
          real_estates: realEstates ?? undefined
        })
      }
      onChangeSegmentation={(segment) =>
        setQueryParams({ ...queryParams, segment_by: segment ?? undefined })
      }
      period={period}
      selectedRealEstates={queryParams.real_estates}
      segmentation={queryParams.segment_by}
      settings={settings}
      sx={sx}
    />
  )
}

export default MetricQueryParamsFooter
